import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false })

export const whiteList = [
  'Landing Page',
  'Login',
  'Demo',
  'forgot-password',
  'reset-password',
  'email-confirmation',
  'email-pending',
  'privacy-policy'
]

router.beforeEach((to, from, next) => {
  NProgress.start()

  if (localStorage.LuxTag) {
    if (JSON.parse(localStorage.LuxTag).user.token) {
      if (to.path === '/login') {
        next({ name: 'Home' })
        NProgress.done()
      } else {
        if (!store.getters.permission_routers) {
          store
            .dispatch(
              'GenerateRoutes',
              JSON.parse(localStorage.LuxTag).user.name
            )
            .then(() => {
              router.addRoutes(store.getters.addRouters)
              next({ ...to, replace: true })
            })
            .catch(err => {
              store.dispatch('LogOut').then(() => {
                if (whiteList.includes(to.name)) {
                  Message.closeAll()
                  next()
                } else {
                  Message.error(
                    err || 'Verification failed, please login again'
                  )
                  next({ name: 'Login' })
                }
              })
            })
        } else {
          next()
        }
      }
    } else {
      if (whiteList.includes(to.name)) {
        next()
      } else {
        next('/')
        NProgress.done()
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      next()
    } else {
      next('/')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js